module.exports = __webpack_public_path__ + "static/media/FigmaDesignLibrary.e051c9f4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/FigmaDesignLibrary.gif
// module id = 92
// module chunks = 0